/**
 * @generated SignedSource<<5e4a0b4f914cbdbb0312a353542384d1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView$data = {
  readonly selectedGroupsConnection: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView";
};
export type ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView$key = {
  readonly " $data"?: ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueFieldMultiGroupPickerReadviewFull_MultiGroupPickerReadView",
  "selections": [
    {
      "concreteType": "JiraGroupConnection",
      "kind": "LinkedField",
      "name": "selectedGroupsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                },
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraMultipleGroupPickerField"
};

(node as any).hash = "e7a12645b4d832047ab02c9f7b91d410";

export default node;
